<template>
    <input class="form-control" type="number" v-model="value" :name="name"
           :min="min"
           :max="max"
           v-on:change="handleChange"
           :placeholder="min + ' - ' + max">
</template>

<script>
export default {
    name: "question-integer",

    props: {
        name: {
            required: true
        },
        min: {
            type: Number
        },
        max: {
            type: Number
        },
        threshold: {
            type: Number
        }
    },

    data() {
        return {
            value: null,
            below_threshold: false
        }
    },

    methods: {
        handleChange() {
            this.threshold !== null ? (this.value < this.threshold && this.value !== '' ? this.below_threshold = true : this.below_threshold = false) : ''
        }
    },

    watch: {
        value: function (newVal) {
            this.$emit('input', newVal);
        },
        below_threshold: function (newVal) {
            this.$emit('isBelowThreshold', newVal);
        },

    }
}
</script>

<style scoped>

</style>
